

































































// vendor
import { computed, defineComponent, PropType, ref, set } from "@vue/composition-api";
// project
import * as DOMUtils from "@/utils/dom";
// import { useRouteCustomParams } from "@/hooks/useRouteCustomParams";
import { Study } from "@/psychlab/types";
import * as StudyAPI from "@/services/api/studies";

export default defineComponent({
	props: {
		study: {
			type: Object as PropType<Study>,
			required:true,
		},
	},
	setup(props, ctx) {

		const toggling = ref(false);
		
		// const { studyId } = useRouteCustomParams(ctx);

		const studyId = computed(() => {
			const r = ctx.root.$route;
			return r.params["studyId"] || r.params["groupId"];
		});

		const copyShareLinkDisabled = computed(
			() => !(props.study?.enabled || false),
		);

		const shareLink = computed(
			() => `${window.location.origin}/p/s/${studyId.value}`,
		);

		const shareLinkInputValue = computed(() =>
			props.study?.enabled ? shareLink.value : "Share link disabled",
		);

		const copyShareLink = () => {
			DOMUtils.copyToClipboard("shareLink");
		};

		return {
			copyShareLink,
			shareLinkInputValue,
			copyShareLinkDisabled,
		};
	},
});
